import React from "react";
import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const colors = {
  pdf: "rgba(202,35,29,0.87)",
  doc: "rgba(43,87,154,0.87)",
  xls: "rgba(33,115,70,0.87)",
  ppt: "rgba(210,71,38,0.87)",
  txt: "rgba(100,100,100,0.87)",
};

interface Props {
  fileType: string;
}

/** ファイル種類アイコン */
export function FileTypeIcon(props: Props) {
  const { fileType } = props;

  let icon;
  let iconColor;
  if (fileType === "PDF") {
    icon = faFilePdf;
    iconColor = colors.pdf;
  } else if (fileType === "ワード") {
    icon = faFileWord;
    iconColor = colors.doc;
  } else if (fileType === "エクセル") {
    icon = faFileExcel;
    iconColor = colors.xls;
  } else if (fileType === "パワーポイント") {
    icon = faFilePowerpoint;
    iconColor = colors.ppt;
  } else if (fileType === "テキスト") {
    icon = faFileAlt;
    iconColor = colors.txt;
  }

  //--------------------
  // コンポーネント
  return icon && iconColor ? (
    <FontAwesomeIcon
      icon={icon}
      style={{
        color: iconColor,
        marginRight: "0.4rem",
      }}
    />
  ) : (
    <span />
  );
}
